import React, {useEffect} from 'react'
import '@css/index.scss'
import Layout from '@components/common/layout/layout'
import Testimonial from '../components/homepage/testimonialSection/testimonial'
import FocusSection from '../components/homepage/focusSection/focusSection'
import BenefitSection from '../components/homepage/benefitSection/benefitSection'
import TemplateSection from '../components/homepage/templateSection/templateSection'
import IndustrySection from '../components/homepage/industrySection/industrySection'
import HeroSection from '../components/homepage/heroSection/heroSection'
import FeatureSectionWrapper from "../components/homepage/featureSectionWrapper/featureSectionWrapper";
import CompleteSolutionSection from '../components/homepage/completeSolutionSection/completeSolutionSection'
import Footer from "../components/common/footer/footer";
import TrafftHelpRow from "../components/homepage/trafftHelpRow/trafftHelpRow";
import AutomateBusiness from "../components/homepage/automateBusiness/automateBusiness";
import MobileApp from "../components/homepage/mobileApp/mobileApp";
import WordpressPlugin from "../components/homepage/wordpressPlugin/wordpressPlugin";
import BookingsChannels from "../components/homepage/bookingsChannels/bookingsChannels";
import {redirectToTryForFree} from "../utils/redirectToTryForFree";
import SupportComponent from "../components/why-trafft/support/support";
import HomepageFeaturesCardsWrapper from "../components/homepage/homepageFeaturesCardsWrapper/homepageFeaturesCardsWrapper";
import FeaturedOn from "../components/homepage/featuredOn/featuredOn";
import {SEO} from "../components/common/seo/seo";
import Meta from "../utils/meta";

export const Head = () =>
<>
  <SEO
    page={Meta.Meta.Homepage}
  />
</>

const IndexPage = () => {
  useEffect(() => {
    window.addEventListener('onTouchStart', function (event) {
      event.preventDefault()
    }, {passive: false})
    window.addEventListener('onTouchMove', function (event) {
      event.preventDefault()
    }, {passive: false})
    window.addEventListener('onWheel', function (event) {
      event.preventDefault()
    }, {passive: false})

  }, []);

  return (
    <Layout>

      <HeroSection/>

      <HomepageFeaturesCardsWrapper/>

      <AutomateBusiness/>

      <BookingsChannels/>

      <WordpressPlugin/>

      <Testimonial/>

      <FeaturedOn/>

      <CompleteSolutionSection/>

      <MobileApp/>

      <IndustrySection/>

      <BenefitSection/>

      <TemplateSection/>

      <FocusSection/>

      <TrafftHelpRow/>

      <FeatureSectionWrapper/>

      <SupportComponent
        title='We’re here for you'
        description='If you have any questions about Trafft features or if you’re experiencing any issues, feel free to contact our support team and they will provide you with the answer as soon as possible. Also, if you need any help during onboarding, our support team will be happy to help. '
      />

      <Footer
        animationColor='#005AEE'
        animationStopColor='#2F7EFF'
        buttonType='primary'
        buttonLabel='Try Now For Free'
        buttonOnClick={redirectToTryForFree}
      />
    </Layout>
  )
}

export default IndexPage
